function whatOS() {
  var isMobile = {
    Android: function () {
      return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function () {
      return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function () {
      return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function () {
      return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
    },
    any: function () {
      return (
        isMobile.Android() ||
        isMobile.BlackBerry() ||
        isMobile.iOS() ||
        isMobile.Opera() ||
        isMobile.Windows()
      );
    },
  };
  if (window.navigator.userAgent.indexOf("Win") !== -1) return "Win";
  if (window.navigator.userAgent.indexOf("Mac") !== -1) return "Mac";
  if (window.navigator.userAgent.indexOf("X11") !== -1) return "UNIX";
  if (window.navigator.userAgent.indexOf("Linux") !== -1) return "Linux";
  if (isMobile.any()) return "Mobile";
}

const whichOS = whatOS();

export default whichOS;
